// extracted by mini-css-extract-plugin
export default {"woBorderContainer":"TimeSelector_woBorderContainer__rqi3X","colon":"TimeSelector_colon__AZwAT"};